import { render, staticRenderFns } from "./Taskapp.vue?vue&type=template&id=a28534da&scoped=true&"
import script from "./Taskapp.vue?vue&type=script&lang=ts&"
export * from "./Taskapp.vue?vue&type=script&lang=ts&"
import style0 from "./Taskapp.vue?vue&type=style&index=0&id=a28534da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28534da",
  null
  
)

export default component.exports